import React from 'react';
import BaseSelect from 'shared/inputs/BaseSelect';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error } from '@progress/kendo-react-labels';

const defaultData = [];

/**
 * @deprecated Use /shared/components/formControls components instead.
 */
const FormSelect = (fieldRenderProps) => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    optional,
    readOnly,
    data = defaultData,
    textField = 'name',
    dataItemKey = 'id',
    noWrapper = false,
    horizontal = false,
    labelStyle,
    wrapperClassName,
    filterable,
    ...others
  } = fieldRenderProps;

  const showValidationMessage = visited && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : '';

  const content = (
    <div className={horizontal ? 'k-form-field' : 'k-form-field-wrapper'}>
      {label && (
        <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
          {...(readOnly ? { className: 'label-readonly' } : {})}
          style={labelStyle}
        >
          {label}
        </Label>
      )}
      <BaseSelect
        valid={valid}
        id={id}
        disabled={disabled}
        ariaDescribedBy={errorId}
        textField={textField}
        dataItemKey={dataItemKey}
        readOnly={readOnly}
        data={data}
        {...others}
      />
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </div>
  );

  if (noWrapper) {
    return content;
  }
  return <FieldWrapper className={wrapperClassName}>{content}</FieldWrapper>;
};

export default FormSelect;
